<template>
	<div>
		<el-container>
			<el-header>
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">{{ $t('monitoringCenter.home') }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ $t('deviceControl.OperationsCenter') }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ $t('chong-dian-zhuang-shang-xian-ji-lu') }}</el-breadcrumb-item>
				</el-breadcrumb>
			</el-header>
			<el-main>
				<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
					<!--列表-->
					<el-tab-pane :label="$t('chong-dian-zhuang-shang-xian-ji-lu-0')" name="station">
						<el-main>
							<!-- 搜索筛选 -->
							<el-form :inline="true" :model="formInline" class="user-search">
								<el-form-item>
									<el-cascader size="mini" clearable ref="cascader" :placeholder="$t('deviceControl.operatorId')" filterable
										:options="operatorForSelect"
										:props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false"
										change-on-select @change='handleChangeOperator'
										v-model="formInline.t.operatorId">
									</el-cascader>
								</el-form-item>
								<el-form-item label="">
									<el-select clearable size="mini" v-model="formInline.t.stationCode"
										:placeholder="$t('xuan-ze-chong-dian-zhan')">
										<el-option v-for="item in stationData" :key="item.stationCode"
											:label="item.stationName" :value="item.stationCode" />
									</el-select>
								</el-form-item>
								<el-form-item label="">
									<el-input size="mini" v-model="formInline.t.pileCode" :placeholder="$t('paramMonitor.pileCode')" />
								</el-form-item>
								<el-form-item>
									<el-button size="mini" type="primary" icon="el-icon-search" @click="search">
										{{ $t('deviceControl.search') }}</el-button>
									<!--<el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>-->
								</el-form-item>
							</el-form>
							<!--列表-->
							<el-table size="mini" :data="userData" highlight-current-row v-loading="loading" border
								:element-loading-text="$t('paramMonitor.Loading')" style="width: 100%;">
								<af-table-column align="center" prop="id" :label="$t('deviceControl.operatorId')" width="80" />
								<af-table-column align="center" :show-overflow-tooltip="true" prop="stationName"
									:label="$t('deviceControl.stationId')" width="100" />
								<!--<af-table-column align="center" :show-overflow-tooltip="true" prop="pileName" label="桩编号" width="100"/>-->
								<af-table-column align="center" :show-overflow-tooltip="true" prop="gunCode" :label="$t('deviceControl.pileId')"
									width="100" />
								<af-table-column align="center" prop="phone" :label="$t('shang-ci-shang-xian-di-zhi')" min-width="120" />
								<af-table-column align="center" :show-overflow-tooltip="true" prop="repairType.message"
									:label="$t('ben-ci-shang-xian-di-zhi')" min-width="120" />
								<af-table-column align="center" :show-overflow-tooltip="true" prop="content"
									label="$t('xin-tiao-zhou-qi')" width="250" />
								<af-table-column align="center" prop="reportTime" :label="$t('xin-tiao-chao-shi-ci-shu')" min-width="135" />
								<af-table-column align="center" prop="handState.message" :label="$t('she-bei-xi-tong-shi-jian')"
									min-width="80" />
								<af-table-column align="center" prop="requestSource.message" :label="$t('shang-xian-shi-jian')" width="100" />
								<af-table-column :label="$t('deviceControl.operation')" width="160">
									<template slot-scope="scope">
										<el-popover style="margin-right: 10px;" placement="top" width="260">
											{{ $t('ci-chu-shi-nei-rong') }}
											<div style="text-align: center">
												<el-button type="primary" size="mini"
													@click="faultListingFormSubmit(scope.row)"
													:loading="faultListingSubmitLoading">{{ $t('fu-zhi') }}</el-button>
											</div>
											<el-button slot="reference" size="mini" class="faultListing" plain type="primary">{{ $t('xiang-qing-0') }}
											</el-button>
										</el-popover>
									</template>
								</af-table-column>
							</el-table>
							<!-- 分页组件 -->
							<Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>
							<div class="line"></div>
						</el-main>
					</el-tab-pane>
				</el-tabs>
			</el-main>
		</el-container>
	</div>
</template>
<script type="text/ecmascript-6">
	import Pagination from '@/module/operatingCenter/component/Pagination';
	import api1 from '@/module/maintenanceCenter/api/faultRepair.js';
	import api from '@/module/operatingCenter/api/commonApi.js';
	import commonApi from '@/common/api/commonFromVuexApi.js';
	import enumApi from "@/common/api/enumApi.js";

	export default {
		data() {
			return {
				loading: false, // 是显示加载
				activeName: 'station',
				faultListingSubmitLoading: false,
				formInline: {// 请求数据参数
					t: {
						stationCode: '',
						pileCode: '',
						operatorId: ''
					}
				},
				pageParam: {// 分页参数
					currentPage: 1,
					pageSize: 10,
					total: 10
				},
				userData: [],// 列表数据
				stationData: [],//站点数据
				operatorForSelect: [],// 运营商数据
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		watch: {},
		created() {
			// 获取场站数据
			// this.getData(this.formInline);
			this.getStationData();
			this.getOperators();
		},
		mounted: function() {
			let tab = {}
			tab.name = "device"
			this.handleClick(tab)
		},
		methods: {
			handleClick(tab, event) {},
			// 获取站点
			getStationData() {
				commonApi.getStations().then((res) => {
					this.stationData = res;
				})

			},
			// 运营商下拉框
			getOperators() {
				api.getOperatorsTree().then((res) => {
					if (res.code === 0) {
						this.operatorForSelect = res.data
					}
				})
			},
			// 获取数据方法
			getData(parameter) {
				this.loading = true;
				api1.getPage(parameter).then((res) => {
					this.userData = res.data.list;
					// 分页赋值
					this.pageParam.currentPage = res.data.pageNum;
					this.pageParam.total = res.data.total
					// 加载结束
					this.loading = false
				}).catch(error => {
					this.loading = false;
				})
			},
			// 选中运营商
			handleChangeOperator(value) {
				let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
				this.formInline.t.operatorId = operatorId
				this.$refs.cascader.dropDownVisible = false
			},
			faultListingFormSubmit(row){
				console.log(row)
			},
			// 分页插件事件
			callFather() {
				let data = {
					currentPage: this.pageParam.currentPage,
					pageSize: this.pageParam.pageSize,
					t: this.formInline.t
				}
				this.getData(data)
			},
			// 搜索事件
			search() {
				this.getData(this.formInline)
			},
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/station.vue